import {Button, Container, Dropdown, Form, FormControl, Nav, Navbar} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {SigninModal} from "./SigninModal";
import {useAuth} from "../contexts/AuthContext";

export default function NavbarWithSearch() {

    const location = useLocation();
    const navigate = useNavigate();
    const {user, signout, isLoading} = useAuth();

    const params = new URLSearchParams(location.search);
    const qParam = params.get("q") || "";

    const [query, setQuery] = useState("");
    const [showSigninModal, setShowSigninModal] = useState(false);

    // Synchronizuj pole tylko na stronie search
    useEffect(() => {
        if (location.pathname === "/search") {
            setQuery(qParam);
        } else {
            setQuery("");
        }
    }, [location.pathname, qParam]);

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // zapobiega domyślnej akcji submit formularza
            navigate(`/search?q=${encodeURIComponent(query)}`);
        }
    };

    return (
        <>
            <Navbar bg="dark" variant="dark" expand="lg">
                <Container fluid className="d-flex justify-content-between" style={{width: "1320px"}}>
                    <div className="d-flex align-items-center">
                        <Navbar.Brand as={Link} to="/">QuickApp</Navbar.Brand>
                        {location.pathname !== "/" &&
                            <Form className="d-flex ms-3" onSubmit={(e) => e.preventDefault()}>
                                <FormControl
                                    type="search"
                                    placeholder="Szukaj"
                                    className="me-2"
                                    aria-label="Search"
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    onKeyUp={handleKeyPress}
                                />
                            </Form>
                        }
                    </div>

                    <div className="d-flex align-items-center">
                        {!isLoading && (
                            <>
                                {user ? (
                                    <Dropdown>
                                        <Dropdown.Toggle variant="dark" className="d-flex align-items-center border-0 bg-transparent">
                                            {user.picture && (
                                                <img 
                                                    src={user.picture} 
                                                    alt={user.name || user.email} 
                                                    className="rounded-circle me-2"
                                                    style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                                                />
                                            )}
                                            {!user.picture && (
                                                <div 
                                                    className="rounded-circle me-2 d-flex align-items-center justify-content-center bg-secondary text-white"
                                                    style={{ width: '32px', height: '32px', fontSize: '14px' }}
                                                >
                                                    {(user.name || user.email || 'U').charAt(0).toUpperCase()}
                                                </div>
                                            )}
                                            <span>{user.name || user.preferred_username || user.email || 'User'}</span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => signout()}>Sign out</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                ) : (
                                    <Button variant="outline-light" size="sm" onClick={() => setShowSigninModal(true)}>Signin</Button>
                                )}
                            </>
                        )}
                    </div>
                </Container>
            </Navbar>
            <SigninModal show={showSigninModal} onClose={() => setShowSigninModal(false)} />
        </>
    )
}